import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /configuration is a container — redirect to the default child
 * (`/configuration/manager`, which itself lands on `/parameters`) so the URL
 * is always explicit about which page is active.
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/configuration/manager', search });
  },
});
